import { create } from 'zustand';

/** Local date string (YYYY-MM-DD) for `d`, in the browser/tenant timezone. */
export function toDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export interface BookingTarget {
  sessionId: number | null; // null = create
  prefill: { employeeId?: number | null; start?: string } | null;
}

export type CalendarViewMode = 'day' | 'week' | 'month';
export type AppPage = 'calendar' | 'dashboard' | 'reports' | 'audit';

interface UiState {
  branchId: number | null;
  date: string;
  view: CalendarViewMode;
  page: AppPage;
  booking: BookingTarget | null;
  setBranch: (id: number) => void;
  setDate: (date: string) => void;
  setView: (view: CalendarViewMode) => void;
  setPage: (page: AppPage) => void;
  shiftDate: (days: number) => void;
  today: () => void;
  openCreate: (prefill: BookingTarget['prefill']) => void;
  openEdit: (sessionId: number) => void;
  closeBooking: () => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  branchId: null,
  date: toDateStr(new Date()),
  view: 'day',
  page: 'calendar',
  booking: null,
  setBranch: (id) => set({ branchId: id }),
  setDate: (date) => set({ date }),
  setView: (view) => set({ view }),
  setPage: (page) => set({ page }),
  shiftDate: (days) => {
    const d = new Date(`${get().date}T00:00:00`);
    const view = get().view;
    if (view === 'month') d.setMonth(d.getMonth() + days);
    else if (view === 'week') d.setDate(d.getDate() + days * 7);
    else d.setDate(d.getDate() + days);
    set({ date: toDateStr(d) });
  },
  today: () => set({ date: toDateStr(new Date()) }),
  openCreate: (prefill) => set({ booking: { sessionId: null, prefill } }),
  openEdit: (sessionId) => set({ booking: { sessionId, prefill: null } }),
  closeBooking: () => set({ booking: null }),
}));
